import React , {useState} from 'react'
import './Navbar.scss';
import { images } from '../../constants';
import {HiMenuAlt4, HiX} from 'react-icons/hi';
import {motion} from 'framer-motion';
import { FaDownload } from 'react-icons/fa';

const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  const handleDownloadPDF = () => {
    const pdfUrl = images.Om_Singh_Resume; // Adjust the path to your PDF file
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = 'Om_Singh_Resume.pdf'; // Set the desired file name for the download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <nav className='app__navbar'>
      <div className='app__navbar-logo'>
        <img src={images.logo} alt='logo'/>
      </div>
      <ul className='app__navbar-links'>
        {['Home', 'About', 'Projects', 'Skills', 'Achievements', 'Contacts'].map((item)=>(
          <li className='app__flex p-text' key={`link-${item}`}>
            <div />
            <a href={`#${item}`}>{item}</a>
          </li>
        ))}
      </ul>
      <div className='app__navbar-menu'>
        <HiMenuAlt4 onClick={()=> setToggle(true)} />
        {toggle && (
          <motion.div
          whileInView={{x: [300,0]}}
          transition={{duration : 0.85, ease:'easeOut'}}
          >
            <HiX onClick={()=>setToggle(false)} />
            <ul className='app__navbar-links'>
              {['Home', 'About', 'Projects', 'Skills', 'Achievements', 'Contact'].map((item)=>(
                <li key={item}>
                  <a href={`#${item}`} onClick={()=>setToggle(false)} >{item}</a>
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;